import type { PdfComponent } from '../../../TermsAndConditionsRender/components/typed';

export const SECTION10: PdfComponent = {
  type: 'section',
  id: 's1s10',
  title: '10. Risk and Liability',
  content: [
    {
      type: 'bulletList',
      id: 's1s10bullets',
      bulletType: 'number',
      content: [
        {
          copy: 'Each party shall:',
          sublist: {
            bulletType: 'number',
            content: [
              {
                copy: 'be liable for any breaches of Data Privacy Laws caused by its own act or omission, including any fines, penalties, compensation payable to Data Subjects, and any other remedial action necessary (including changes to information technology systems and additional staff training) resulting from such breach; and',
              },
              {
                copy: 'hold harmless and fully indemnify the other party for any loss (including fines, penalties, compensation to Data Subjects, and related costs) suffered or incurred by the other party as a result of its breach of this Agreement or of the Data Privacy Laws.',
              },
            ],
          },
        },
      ],
      prefix: '10',
    },
  ],
};
